import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalSelectedDocuments: number
  loading: boolean
  onSubmit: () => void
  onClose: () => void
}

const ResendSignatureReminderModal = ({
  totalSelectedDocuments,
  loading,
  onSubmit,
  onClose,
}: Props) => {
  return (
    <Modal
      illustration="bell"
      title={i18n.t('documents.employee.bulk-actions.resend-signature.title', {
        count: totalSelectedDocuments,
      })}
      description={i18n.tp('documents.employee.bulk-actions.resend-signature.description', {
        count: totalSelectedDocuments,
      })}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit loading={loading}>
            {i18n.t('documents.employee.bulk-actions.resend-signature.submit')}
          </Button>
        </>
      }
    />
  )
}

export default ResendSignatureReminderModal
